/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import ToggleSwitch from "../components/toggles/ToggleSwitch";
import styled from "styled-components";
import { addBarcodes } from "../utils/addBarcodes";
import BarcodeReader from "react-barcode-reader";
import SolidButton from "../components/buttons/solid-button/SolidButton";
import { useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import Banner from "../components/hero/Banner";
import Header from "../components/header/Header";
import Container from "../components/container/Container";
import SuccessFlash from "../components/flash_message/SuccessFlash";
import ErrorFlash from "../components/flash_message/ErrorFlash";
import FormValidationError from "../components/flash_message/FormValidationError";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useAuth from "../hooks/useAuth";
import ModalDrop from "../components/modals/ModalDrop";
import ScanError from "../components/scanning-error/ScanError";
import moment from "moment";
const Input = styled.input`
	width: ${(props) => props.width};
	border: 1px solid #d6d6d6;
	color: black;
	font-size: 16px;
	border-radius: 5px;
	height: 40px;
	padding: 0 5px;
`;
const Label = styled.label`
	width: 100%;
	color: #8a8a8a;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0px;
	text-align: left;
`;
const FormInputControl = styled.div`
	width: 100%;
	margin: 10px 0;
`;

function DispensePackage() {
	const [count, setCount] = useState(0);
	const axiosprivate = useAxiosPrivate();
	const location = useLocation();
	const { auth, setLoading } = useAuth();
	const [scanCodes, setsSanCodes] = useState([]);
	const [barcode, setBarcode] = useState("Scan barcode...................");
	const [isBatch, setIsBatch] = useState(false);
	const [longitude, setLongitude] = useState("");
	const [latitude, setLatitude] = useState("");
	const [isSuccess, setIsSuccess] = useState(false);
	const [isFail, setIsFail] = useState(false);
	const navigate = useNavigate();
	const [message, setMessage] = useState("Success");
	const [incompleteScan, setIncompleteScan] = useState(false);
	const [customerName, setCustomerName] = useState("");
	const [scanError, setScanError] = useState({
		show: false,
		errorMessage: "",
		barcode: "",
	});

	useEffect(() => {
		count === 1 && !isBatch && handleSubmit();
	}, [isBatch, count]);

	//clear out scan box
	useEffect(() => {
		setTimeout(() => {
			setBarcode("Scan barcode...................");
		}, 1000);
		return () => {
			clearTimeout();
		};
	}, [barcode]);

	useEffect(() => {
		navigator.permissions.query({ name: "geolocation" }).then((resp) => {
			if (resp.state === "granted") {
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(success, error);
				}
			} else if (resp.state === "denied") {
				navigate("/", { state: { from: location }, replace: true });
			}
		});

		function success(position) {
			setLatitude(`${position.coords.latitude}`);
			setLongitude(`${position.coords.longitude}`);
		}

		function error(err) {
			console.error(err);
			navigate("/", { state: { from: location }, replace: true });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	//toggle state
	const logState = (state) => {
		setsSanCodes([]);
		setCount(0);
		setIsBatch(state);
	};

	//get barcodes
	const handleScan = async (data) => {
		setBarcode(data);
		setIncompleteScan(false);
		setIsFail(false);
		setIsSuccess(false);

		if (isBatch) {
			//check if label is SSCC
			if (
				data.substring(0, 2) === "00" &&
				data.substring(3, 6) === "615"
			) {
				setIsFail(true);
				setMessage("You cannot Dispense with SSCC");
			} else {
				if (data.length < 40) {
					setIncompleteScan(true);
					return;
				} else {
					let filteredArray = addBarcodes(data, scanCodes);
					setsSanCodes([...filteredArray]);
					setCount(filteredArray.length);
					return;
				}
			}
		} else {
			//check if label is SSCC
			if (
				data.substring(0, 2) === "00" &&
				data.substring(3, 6) === "615"
			) {
				setIsFail(true);
				setMessage("You cannot Dispense with SSCC");
			} else {
				if (data.length < 40) {
					setIncompleteScan(true);
					return;
				} else {
					let filteredArray = addBarcodes(data, scanCodes);
					setsSanCodes([...filteredArray]);
					setCount(filteredArray.length);
					return;
				}
			}
		}
	};

	//handle error
	function handleError(err) {
		console.error(err);
	}

	//Endpoint to ship package
	const dispensing = async (data) => {
		return await axiosprivate.post("/gs1/standard/label/dispense", data);
	};

	const resetScanError = () => {
		setScanError({ show: false, errorMessage: "", barcode: "" });
	};

	//query to send to backend
	const { mutate, isLoading } = useMutation(
		(variables) => dispensing(variables),
		{
			onSuccess(data, variables, context) {
				setsSanCodes([]);
				setCount(0);
				setIsSuccess(true);
				setMessage("Success");
			},
			onError(error) {
				setsSanCodes([]);
				setCount(0);
				setIsFail(true);
				if (error.code === "ERR_NETWORK")
					setMessage("Please Check Your Network");
				else if (
					error?.response?.status === 403 ||
					error?.response?.status === 401
				) {
					navigate("/", { state: { from: location }, replace: true });
				} else if (
					error.response?.data?.message?.includes("ER_PARSE_ERROR")
				) {
					setMessage("Unable to dispense package, please try again");
				} else {
					const message = error.response.data.message;
					if (
						message.includes("SQL") ||
						error?.response?.status === 500
					) {
						setMessage("Server Error");
					} else {
						setMessage(
							error.response.data.message?.replace(
								"Unknow",
								"Unknown"
							)
						);
					}
				}
			},
		}
	);

	//handle submit
	const handleSubmit = () => {
		const offset = moment().format("Z");
		const payload = {
			clientId: auth.user.clientId,
			eventObjectParameter: {
				eventTime: new Date().toISOString().replace("Z", ""),
				recordTime: new Date().toISOString().replace("Z", ""),
				readPoint: auth.user.location,
				latitude: latitude,
				longitude: longitude,
				// bizStep: "urn:epcglobal:cbv:bizstep:dispensing",
				disposition: "urn:epcglobal:cbv:disp:active",
				timeZone: offset,
			},
			dispensingData: {
				elementstrings: scanCodes,
				dispensestatus: "FULL",
				staffidentifier: "",
				patientidentifier: customerName,
			},
		};
		mutate(payload);
	};

	useEffect(() => {
		setLoading(isLoading);
	}, [isLoading, setLoading]);
	return (
		<Container>
			{scanError.show && (
				<ModalDrop>
					<ScanError
						onClose={resetScanError}
						barCode={scanError.barcode}
						errorMessage={scanError.errorMessage}
					/>
				</ModalDrop>
			)}
			<BarcodeReader
				onError={handleError}
				onScan={handleScan}
				timeBeforeScanTest={1000}
			/>
			<Header>{"Dispense Package"}</Header>
			<div style={{ position: "relative", margin: "20px 0" }}>
				<ToggleSwitch toggled={false} onClick={logState} />
			</div>
			<Banner />

			<div>
				<small
					style={{
						fontSize: "12px",
						marginTop: "8px",
						marginBottom: "8px",
						display: "block",
					}}
				>
					Please enter the Customer name first, then click on the "scan barcode" field, before
					scanning labels for packages to be dispensed.{" "}
					{isBatch
						? " Then click the 'Submit' button when you are done"
						: ""}
				</small>
			</div>
			<FormInputControl>
				<Label>Customer Name</Label>
			</FormInputControl>
			<FormInputControl>
				<Input
					width={"100%"}
					value={customerName}
					onChange={(e) => {
						setCustomerName(e.target.value);
					}}
				/>
				{customerName.length < 5 && (
					<FormValidationError text={"Customer name is required"} />
				)}
			</FormInputControl>
			<FormInputControl>
				<Label>Barcode</Label>
			</FormInputControl>
			<FormInputControl>
				<Input
					value={barcode}
					width={"100%"}
					style={{ fontSize: "12px" }}
					disabled
				/>
				{incompleteScan && (
					<FormValidationError
						text={"Incomplete scan.. please rescan!!!!"}
					/>
				)}
			</FormInputControl>
			<FormInputControl>
				<Label>Quantity</Label>
			</FormInputControl>
			<FormInputControl>
				<Input width={"100%"} value={count} disabled type="number" />
			</FormInputControl>

			{isBatch && count > 0 && !isLoading && (
				<FormInputControl style={{ marginTop: "40px" }}>
					<SolidButton width={"100%"} onclick={handleSubmit} />
				</FormInputControl>
			)}

			<FormInputControl style={{ marginTop: "20px" }}>
				<SuccessFlash display={isSuccess}>{message}</SuccessFlash>
			</FormInputControl>

			<FormInputControl style={{ marginTop: "20px" }}>
				<ErrorFlash display={isFail}>{message}</ErrorFlash>
			</FormInputControl>
		</Container>
	);
}

export default DispensePackage;
